import React from 'react';
import { motion } from 'framer-motion';
import { Lock } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function FinalCTA() {
  return <section id="comprar" className="bg-navy text-white py-24 px-6 relative overflow-hidden" data-id="element-37">
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-teal via-navy to-navy" data-id="element-38"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-39">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-40">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6 leading-tight" data-id="element-41">
            No tienes que seguir viviendo con el miedo constante.
          </h2>

          <p className="text-xl text-gray-300 mb-10" data-id="element-42">
            Obtén el Protocolo SOS hoy mismo y recupera el control de tu hogar y
            tus salidas.
          </p>

          <div className="bg-white/5 border border-white/10 rounded-2xl p-8 backdrop-blur-sm mb-8" data-id="element-43">
            <p className="text-teal-300 font-medium tracking-widest uppercase text-sm mb-2" data-id="element-44">
              Acceso Inmediato
            </p>
            <div className="flex items-center justify-center gap-2 mb-6" data-id="element-45">
              <span className="text-5xl font-bold text-white" data-id="element-46">$14</span>
              <span className="text-xl text-gray-400 mt-2" data-id="element-47">.00</span>
            </div>

            <a href="https://soscalma.com/cart/52072115110201:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="block w-full bg-copper hover:bg-[#b86a3d] text-white font-bold py-5 px-8 rounded-xl text-xl transition-all transform hover:scale-105 shadow-[0_0_30px_rgba(201,123,75,0.5)]" data-id="element-48">
              ¡SÍ, QUIERO EL PROTOCOLO SOS AHORA!
            </a>

            <p className="text-sm text-gray-400 mt-6 flex items-center justify-center gap-2" data-id="element-49">
              <Lock className="w-4 h-4" data-id="element-50" />
              Pago 100% seguro. Recibes tu acceso digital al instante.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}